<template>
  <ul class="tags" :class="{ small }">
    <li v-for="tag in tags" :key="tag.id" class="tag" :style="{ background: tag.color }">
      <TagIcon v-if="tag.icon" :id="tag.icon" class="icon" />{{ tag.name }}
    </li>
  </ul>
</template>

<script>
import TagIcon from '@/components/icons/TagIcon'

export default {
  name: 'TagLabels',
  components: {
    TagIcon,
  },
  props: {
    tags: { type: Array, required: true },
    small: Boolean,
  },
}
</script>

<style lang="postcss" scoped>
.tags {
  display: flex;
  flex-wrap: wrap;
  margin: -4px;
}

.tag {
  align-items: center;
  background: var(--dark-gray);
  color: var(--white);
  display: flex;
  fill: var(--white);
  font-size: 15px;
  font-weight: bold;
  height: 24px;
  line-height: 1;
  margin: 4px;
  padding: 0 16px;
  width: fit-content;
}

.icon {
  height: 16px;
  margin: 0 8px 0 -8px;
  width: 16px;
}

.small {
  margin: -4px -2px;

  .tag {
    font-size: 12px;
    height: 16px;
    margin: 4px 2px;
    padding: 0 4px;
  }

  .icon {
    margin: 0 4px 0 0;
  }
}
</style>
